



















import { Vue } from 'vue-property-decorator';
import Splitpanes from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { mapActions, mapGetters } from 'vuex';
import { StickyStoreNames, StickySettingsFields, StickySettingsGetters, DocumentsToStorePreference } from '@/types';

export default Vue.extend({
  name: 'DocumentsToStoreTreeViewLayout',
  data() {
    return {
      isLoading: false,
      leftPaneSize: 40,
      rightPaneSize: 0,
      minPaneSize: 15,
      maxPaneSize: 65
    };
  },
  methods: {
    ...mapActions('userPreferencesStore', ['setDocumentsToStoreVerticalSlider']),
    initializePaneSize(this: any) {
      const documentType = this.selectedDocumentToStoreDocumentType;
      const documentsToStorePreferences: DocumentsToStorePreference = this.getDocumentsToStorePreferences(
        documentType
      );

      if (
        documentsToStorePreferences &&
        window.innerWidth >= documentsToStorePreferences.verticalSlider.screenWidth
      ) {
        this.leftPaneSize = documentsToStorePreferences.verticalSlider.leftPaneWidth;
      } else {
        this.leftPaneSize = this.LEFT_PANE_SIZE;
      }

      this.rightPaneSize = 100 - this.leftPaneSize;
    },
    onResize(this: any, panes: any) {
      this.leftPaneSize = panes[0].width;
      this.rightPaneSize = panes[1].width;
    },
    onResized(this: any, panes: any): void {
      const documentType = this.selectedDocumentToStoreDocumentType;
      if (documentType) {
        this.setDocumentsToStoreVerticalSlider({
          documentType,
          verticalSlider: {
            leftPaneWidth: this.leftPaneSize,
            screenWidth: window.innerWidth
          }
        } as DocumentsToStorePreference);
      }
    }
  },
  computed: {
    ...mapGetters(StickyStoreNames.DocumentsToStore, [StickySettingsGetters.GetStickyStateField]),
    ...mapGetters('userPreferencesStore', ['getDocumentsToStorePreferences']),
    backgroundColor(this: any): string {
      return this.isLoading ? 'bg-light-gray' : '';
    },
    selectedDocumentToStoreDocumentType(this: any) {
      return this.getStickyStateField
        ? this.getStickyStateField(StickySettingsFields.SelectedDocumentToStoreDocumentType)
        : null;
    }
  },
  watch: {
    selectedDocumentToStoreDocumentType() {
      this.initializePaneSize();
    }
  },
  created(this: any) {
    this.LEFT_PANE_SIZE = 40;
    this.initializePaneSize();
  },
  components: {
    Splitpanes,
    LoadingSpinner
  }
});
